import { Link } from "react-router-dom";
import DramaCard from "@/components/feature/DramaCard";
import { dramas } from "@/mocks/dramas";
import type { Drama } from "@/types";

interface RelatedDramasProps {
  drama: Drama;
}

export default function RelatedDramas({ drama }: RelatedDramasProps) {
  const related = dramas
    .filter((item) => item.id !== drama.id && item.genres.some((genre) => drama.genres.includes(genre)))
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section>
      <div className="mb-5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-movie-line text-lg"></i>
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950">相关推荐</h2>
        </div>
        <Link
          to="/category"
          className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-accent-600 cursor-pointer"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
        {related.map((item) => (
          <DramaCard key={item.id} drama={item} />
        ))}
      </div>
    </section>
  );
}